module.exports = __webpack_public_path__ + "d78b6e2e93fc45e3eef684f89f6bc97c.jpg";